import { useTranslation } from 'react-i18next';
import * as yup from 'yup';
import { validation } from '../registration-rules';
import {useRegistrationConfigHook} from "../../pages/registration/hooks/useRegistrationConfigHook";

const RegistrationCustomerYup = (isPrivate: boolean) => {
  const { validCustomerTypes, getAvailableInsurancesWithDescription } = useRegistrationConfigHook();
  const { t } = useTranslation('registrations');

  const hasValidCustomerTypes = (customerTypeCode: string) => {
    return validCustomerTypes.some((customerType) => customerType.code === customerTypeCode);
  };

  const hasValidInsurance = (customerTypeCode: string, insuranceType: string) => {
    return getAvailableInsurancesWithDescription(customerTypeCode).some((i) => i.code === insuranceType);
  };

  return yup.object({
    firstName: yup.string().required().trim().min(validation.firstName.min).max(validation.firstName.max),
    lastName: yup.string().when([], {
      is: () => isPrivate,
      then: (schema) =>
        schema
        .required()
        .trim()
        .min(validation.lastName.min)
        .max(validation.lastName.max),
      otherwise: (schema) => schema.optional(),
    }),
    address: yup.string().required().trim().min(validation.address.min).max(validation.address.max),
    zipCode: yup.string().required().trim().min(validation.zipCode.min).max(validation.zipCode.max),
    city: yup.string().required().trim().min(validation.city.min).max(validation.city.max),
    phone: yup
      .string()
      .trim()
      .min(validation.phone.min)
      .max(validation.phone.max)
      .matches(validation.phone.regex, { message: () => t('registrations.general.errorPhone') })
      .required(),
    email: yup
      .string()
      .trim()
      .max(validation.email.max)
      .matches(validation.email.regex, {
        message: () => t('registrations.general.errorEmail'),
        excludeEmptyString: true
      })
      .optional(),
    type: yup
      .string()
      .test({
        test: (type) => hasValidCustomerTypes(type ?? ''),
        message: () => t('registrations.general.selectValidCustomerType')
      })
      .required(),

    insuranceType: yup
      .string()
      .when('type', (type: string, _schema: yup.AnySchema) => {
        return _schema.test({
          test: (insuranceType: string) => hasValidInsurance(type, insuranceType),
          message: () => t('registrations.general.selectValidInsurance')
        });
      })
      .required()
  });
};

export default RegistrationCustomerYup;
